import cn from "classnames";
import { gql } from "graphql-request";
import styled from "styled-components";
import { LegacyImage } from "components";
import { getImageFormat } from "lib/utils";
import { TableSaversTableHeadRowContent } from "types/graphql/generated";
import { TableRow } from "./TableRow";

interface Props {
  className?: string;
  content: TableSaversTableHeadRowContent;
}

const TableHeadRow = ({ content: { tableLogo, textLogo, tableText }, className = "" }: Props) => {
  const hasImage = tableLogo?.data?.image;

  return (
    <StyledTableHeadRow className={cn(className, {})}>
      <TableRow>
        <div className="CellName" />
        <div className="CellValueOne">
          {hasImage ? (
            <LegacyImage
              transform={{ format: getImageFormat(tableLogo.data.image.ext) }}
              {...tableLogo.data.image}
              className="TableHeadRow__image"
            />
          ) : (
            <div className="Font_24_32_600 lg:Font_18_26_600 md:Font_14_20_600">{tableText || "Title"}</div>
          )}
        </div>
        <div className="CellValueTwo Font_24_32_600 lg:Font_18_26_600 md:Font_14_20_600">{textLogo}</div>
      </TableRow>
    </StyledTableHeadRow>
  );
};

const StyledTableHeadRow = styled.div`
  padding-bottom: 24px;

  .TableHeadRow__image {
    width: 126px;
    line-height: 0;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .TableHeadRow__image {
      width: 102px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .TableHeadRow__image {
      width: 76.6px;
    }
  }
`;

gql`
  fragment TableSaversTableHeadRowContent on ComponentTableTableSavers {
    tableLogo {
      data {
        id
        image: attributes {
          alt: alternativeText
          src: hash
          width
          height
          ext
        }
      }
    }
    textLogo
    tableText
  }
`;

export { TableHeadRow };
